import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PATIENTS_BASE } from "./patientConstants";

/** Десктопный /new → список клиентов с выбором способа добавления. */
export default function AdminPatientNew() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`${PATIENTS_BASE}?add=1`, { replace: true });
  }, [navigate]);

  return null;
}
